import { useEffect, type FormEvent } from "react";
import type { FlightKey } from "@b2bportal/air-price-watch-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  type UnwatchTripResponse,
  useUnwatchTripForm,
} from "./hooks/useUnwatchTripForm";

interface UnwatchTripViewProps {
  cn: (elementName: string) => string;
  flightKey: FlightKey;
  onSuccess?: (response: UnwatchTripResponse) => void;
  onError?: (error: unknown) => void;
  onSubmittingChange?: (isSubmitting: boolean) => void;
}

export const UnwatchTripView = ({
  cn,
  flightKey,
  onSuccess,
  onError,
  onSubmittingChange,
}: UnwatchTripViewProps): JSX.Element => {
  const { t } = useI18nContext();

  const {
    context: { isSubmitting },
    handlers: { onUnwatchTripSubmit },
  } = useUnwatchTripForm({
    flightKey,
    onSuccess,
    onError,
  });

  useEffect(() => {
    onSubmittingChange?.(isSubmitting);
  }, [isSubmitting]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onUnwatchTripSubmit();
  };

  return (
    <form
      id="unwatch-trip-form"
      className={cn("unwatch-trip-view")}
      onSubmit={handleSubmit}
    >
      <p className={cn("subtitle")}>{t("priceWatch.unwatchTitle")}</p>

      <p className={cn("description")}>{t("priceWatch.unwatchMessage")}</p>
    </form>
  );
};
